import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingSpinner: React.FC = () => {
    return (
        <Box p={5} sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
        </Box>
    );
};

export default LoadingSpinner;
